import { FormAuth } from '@/entities/FormAuth/ui/FormAuth'
import './ui/FormAuth.css'
export default FormAuth
